import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "../DashboardFileManagement.module.css"

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const ConsultantReportsHeader = ({ consultans, consultanID, setConsultantID, state }) => {
    const history = useHistory();

    return (
        <>
            <div className="py-2">
                <div className="container-fluid">
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                        dir="rtl"
                    >
                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                            {/* <Link to={"/FileManagement"}><img className='ms-2' src={arrowIcon} alt="icon" /></Link> */}
                            <a href='#' onClick={history.goBack}>
                                <img className='ms-2' src={arrowIcon} alt="icon" />
                            </a>
                            <div className={styles.text1}>
                                گزارشات
                            </div>
                        </div>

                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-4 mb-2'>
                            {consultans?.map((item) => (
                                <div key={item.id} id={item.id} onClick={() => idHandler(item.id)} className={`d-flex align-items-center justify-content-between mx-3 my-2 ${consultanID?.includes(item.id) ? styles.consultants_info_rounded_container_focused : styles.consultants_info_rounded_container}`}>
                                    <img className={styles.consultant_profile} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="profile-img" />
                                    <div className={`mx-2 ${styles.text_sm_black}`}>
                                        {item.fullName}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    function idHandler(id) {
        setConsultantID([id])
    }
};

export default ConsultantReportsHeader;